import ActionTypes from "../constants/action_types";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {UserId} from "common/types/user";
import {ConversationItemId} from "common/types/conversation";

export default function updateConversationItemFeedback(requestor) {
  return createReduxPromiseAction(
    ActionTypes.CONVERSATION_ITEM_FEEDBACK_UPDATE,
    (
      organisationId,
      projectId,
      documentId,
      covnersationItemId: ConversationItemId,
      userId: UserId,
      text: string,
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document/${documentId}/conversation/item/${covnersationItemId}`,
          {text, user_id: userId},
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
